<style lang="less">
    .slides-panel {
        height: calc(100% + 28px);
        overflow-y: hidden;
        margin: -15px -15px -15px -15px;
        user-select: none;
        position: relative;
        .item-icon {
            width: 20px;
            height: 20px;
        }
        .slides-option {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e0e0e0;
            .add-slide {
                cursor: pointer;
                margin-left: 10px;
                height: 28px;
                display: flex;
                align-items: center;
                > svg {
                    margin-right: 3px;
                }
                > span {
                    line-height: 28px;
                }
            }
            .slide-output {
                width: 80px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                user-select: none;
                cursor: pointer;
            }
            .slide-config {
                position: relative;
                cursor: pointer;
                margin-right: 10px;
                width: 56px;
                height: 20px;

                .icon-box {
                    position: relative;
                    float: left;
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                }
                > svg {
                    margin: 2px;
                    width: 24px;
                    height: 24px;
                }
                .ban-item {
                    opacity: 0.4;
                    cursor: not-allowed;
                }
                .config-dialog {
                    z-index: 1;
                    outline: none;
                    border-radius: 4px;
                    border: 1px solid #e0e0e0;
                    background-color: white;
                    height: 40px;
                    position: fixed;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    left: 88px;
                    top: 80px;
                    width: 188px;
                    .ivu-select {
                        width: 88px;
                    }
                }
                .googleslide-dialog {
                    flex-wrap: wrap;
                    height: 50px;
                    .output-googleslide-btn {
                        width: 100%;
                        height: 24px;
                        line-height: 24px;
                        padding-left: 10px;
                        cursor: pointer;
                        user-select: none;
                        &:hover {
                            background: #eee;
                        }
                    }
                }
            }
        }
        .slides-preview {
            padding: 16px 0;
            height: calc(100% - 195px);
            overflow-y: auto;
            overflow-x: hidden;
            .hidden-slider {
                opacity: 0.3;
            }
            .noSlider-tip {
                width: 150px;
                margin: 0 auto;
                > svg {
                    margin-left: 45px;
                    display: block;
                    width: 60px;
                    height: 60px;
                    fill: var(--svg-color-slide-set);
                    stroke: var(--svg-color-slide-set);
                }
                > div {
                    font-weight: bold;
                    color: var(--text-color-slide-no-slider-tip);
                    text-align: center;
                }
            }
            .list-complete-item {
                transition: all 0.6s;
            }
            .list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active for below version 2.1.8 */ {
                opacity: 0;
            }
            .all-sliders {
                position: relative;
            }
            .sliders-container {
                display: flex;
                margin: 0 16px;
                position: relative;
                align-items: center;
                justify-content: center;
                .slider-index {
                    align-self: flex-start;
                    margin-right: 8px;
                    font-weight: bold;
                    pointer-events: none;
                }
                .canvas-container {
                    background-color: var(--bg-color-primary);
                    margin-bottom: 16px;
                    border-radius: 8px;
                    width: 212px;
                    height: 118px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid var(--border-color-left-panel);
                    overflow: hidden;
                    > canvas {
                        pointer-events: none;
                    }
                    &:hover {
                        border-color: var(--themeColor);
                    }
                }
                .add-icon {
                    position: absolute;
                    bottom: 6px;
                    right: 24px;
                    cursor: pointer;
                    .icon-svg {
                        cursor: pointer;
                        display: none;
                        pointer-events: none;
                        width: 20px;
                        height: 20px;
                        color: #fff;
                        fill: var(--svg-color-active);
                    }
                    .active-icon {
                        display: block;
                    }
                }
                .edit-icon {
                    cursor: pointer;
                    .slider-edit {
                        cursor: pointer;
                        visibility: hidden;
                        pointer-events: none;
                        width: 23px;
                        height: 23px;
                    }
                    .actived-edit {
                        visibility: visible;
                    }
                }
            }

            .actived-slider {
                border-width: 2px !important;
                border-color: var(--themeColor) !important;
            }
        }
        .slides-more {
            position: absolute;
            bottom: 0;
            height: 60px;
            width: 100%;
            border-top: 1px solid var(--border-color-left-panel);
            padding: 12px 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 16px;
            .slidebtn {
                width: 100px;
                height: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0 10px;
                border-radius: 6px;
                border: 1px solid transparent;
                // box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.08);
                .vip-icon {
                    margin-right: 6px;
                    width: 16px;
                    height: 16px;
                }
                p {
                    max-width: 72px;
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .blue {
                background: var(--themeColor);
                border-color: var(--themeColor);
                color: #fff;
                &:hover {
                    background: var(--themeHover);
                    border-color: var(--themeHover);
                }
            }
            .ban {
                filter: opacity(0.5);
                pointer-events: none;
            }
            .gray {
                background: var(--bg-color-primary);
                border-color: var(--border-color-slider-set-export);
                &:hover {
                    background: var(--themeColor);
                    border-color: var(--themeColor);
                    color: #fff;
                }
            }
            .activePre {
                background-color: var(--themeColor) !important;
            }
            .present {
                color: white;
                cursor: pointer;
                padding: 5px 10px;
                height: 30px;
                text-align: center;
                line-height: 20px;
                background-color: #77818c;
                border-radius: 3px;
                &:hover {
                    background-color: #939ba3;
                }
            }
        }
        .slide-context {
            overflow: hidden;
            position: absolute;
            z-index: 1;
            padding-top: 6px;
            padding-bottom: 6px;
            .menu-item {
                max-width: 138px;
                overflow: hidden;
            }
        }
        .slides-ratio {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 50px;
            padding: 0 16px;
            padding-top: 6px;
            .ivu-select {
                width: 110px;
            }
        }
        .slides-tool {
            display: flex;
            justify-content: space-between;
            margin: 0 16px;
            padding-bottom: 16px;
            border-bottom: 1px solid var(--border-color-left-panel);
            .slides-toolblock {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                width: 104px;
                height: 68px;
                border: 1px solid var(--border-color-gray2);
                padding: 6px;
                border-radius: 6px;
                &:first-child {
                    margin-right: 8px;
                }
                cursor: pointer;
                &:hover {
                    background: rgba(0, 0, 0, 0.06);
                }
                p {
                    width: 100%;
                    font-size: 12px;
                    color: var(--text-color-primary);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: center;
                }
                svg {
                    width: 24px;
                    height: 24px;
                    color: var(--svg-color-primary);
                }
            }
        }
    }
</style>
<i18n>
{
  "zh": {
    "title": "幻灯片",
    "newSlide": "新幻灯片",
    "noSliderTip": "添加一个幻灯片以创建演示文稿。",
    "present": "播放",
    "insBefore": "前面插入新幻灯片",
    "insAfter": "后面插入新幻灯片",
    "delete": "删除",
    "ratio": "横纵比",
    "slideOutput": "导出",
    "googleOutput": "导出至googleSlide",
    "slideOption": "幻灯片设置",
    "manual": "手动创建幻灯片",
    "auto": "自动创建幻灯片",
    "autoSlideTips": "这将删除全部幻灯片。您确定要继续吗？"
  },
  "en": {
    "title": "Slides",
    "newSlide": "New Slide",
    "noSliderTip": "Add a slide to create a presentation.",
    "present": "Present",
    "insBefore": "Insert slide before",
    "insAfter": "Insert slide after",
    "delete": "Delete",
    "ratio": "Aspect Ratio",
    "slideOutput": "Export Slide",
    "googleOutput": "Export To Google Slide",
    "slideOption": "Slide Settings",
    "manual": "Create slides manually",
    "auto": "Create slides automatically",
    "autoSlideTips": "This will delete all your slides. Are you sure you want to continue?"
  },
  "fr": {
    "title": "Diaporama",
    "newSlide": "Nouvelle diapositive",
    "noSliderTip": "Ajouter une diapositive pour créer une présentation.",
    "present": "Lire le diaporama",
    "insBefore": "Insérer une nouvelle diapositive à l'avance",
    "insAfter": "Insérer une nouvelle diapositive derrière",
    "delete": "Effacer",
    "ratio": "Rapport d'aspect",
    "slideOutput": "Exporter la diapositive",
    "googleOutput": "Exporter vers googleSlide",
    "slideOption": "Paramètres du diaporama",
    "manual": "Créer des diapositives manuellement",
    "auto": "Création automatique de diapos",
    "autoSlideTips": "Cette opération supprimera toutes vos diapositives. Etes-vous sûr de vouloir continuer?"
  },
  "de": {
    "title": "Folien",
    "newSlide": "Neue Folie",
    "noSliderTip": "Fügen Sie eine Folie hinzu, um eine Präsentation zu erstellen.",
    "present": "Aktuell",
    "insBefore": "Folie vorher einfügen",
    "insAfter": "Folie nachher einfügen",
    "delete": "Löschen",
    "ratio": "Seitenverhältnis",
    "slideOutput": "Folie exportieren",
    "googleOutput": "Nach Google Slide exportieren",
    "slideOption": "Folien Einstellungen",
    "manual": "Folien manuell erstellen",
    "auto": "Folien automatisch erstellen",
    "autoSlideTips": "Dadurch werden alle Ihre Folien gelöscht. Sind Sie sicher, dass Sie fortfahren wollen?"
  },
  "jp": {
    "title": "スライドショー",
    "newSlide": "新規作成",
    "noSliderTip": "スライドを追加してプレゼンテーションを作成します。",
    "present": "スライドショーを作成",
    "insBefore": "前に新しいスライドを挿入",
    "insAfter": "後に新しいスライドを挿入",
    "delete": "削除",
    "ratio": "アスペクト比",
    "slideOutput": "スライドをエクスポート",
    "googleOutput": "Googleスライドにエクスポート",
    "slideOption": "スライド設定",
    "manual": "スライドを手動で作成",
    "auto": "スライドを自動作成",
    "autoSlideTips": "これですべてのスライドが削除されます。続行しますか？"
  },
  "es": {
    "title": "Diapositivas",
    "newSlide": "Nueva diapositiva",
    "noSliderTip": "Añadir una diapositiva para crear una presentación",
    "present": "Presente",
    "insBefore": "Insertar la diapositiva antes",
    "insAfter": "Insertar diapositiva después",
    "delete": "Borrar",
    "ratio": "Relación de aspecto",
    "slideOutput": "Exportar diapositiva",
    "googleOutput": "Exportar a Google Slide",
    "slideOption": "Configuración de la diapositiva",
    "manual": "Crear diapositivas manualmente",
    "auto": "Crear diapositivas automáticamente",
    "autoSlideTips": "Esto eliminará todas sus diapositivas. Estás seguro de que quieres continuar?"
  },
  "pt": {
    "title": "Slides",
    "newSlide": "Slide Novo",
    "noSliderTip": "Adicionar um slide para criar uma apresentação.",
    "present": "Apresentar",
    "insBefore": "Inserir slide antes",
    "insAfter": "Inserir slide depois",
    "delete": "Eliminar",
    "ratio": "Razão de Aspecto",
    "slideOutput": "Exportar Slide",
    "googleOutput": "Exportar para Google Slide",
    "slideOption": "Configurações do Slide",
    "manual": "Criar slides manualmente",
    "auto": "Criar slides automaticamente",
    "autoSlideTips": "Isto apagará todos os seus slides. Você tem a certeza de que deseja prosseguir?"
  },
  "it": {
    "title": "Diapositive",
    "newSlide": "Nuova Diapositiva",
    "noSliderTip": "Aggiungi una diapositiva per creare una presentazione.",
    "present": "Presentazione",
    "insBefore": "Inserisci diapositiva prima",
    "insAfter": "Inserisci diapositiva dopo",
    "delete": "Elimina",
    "ratio": "Rapporto di Aspetto",
    "slideOutput": "Esporta Diapositiva",
    "googleOutput": "Esporta su Presentazioni Google",
    "slideOption": "Impostazioni Diapositiva",
    "manual": "Crea Manualmente",
    "auto": "Crea Automaticamente",
    "autoSlideTips": "Tutte le diapositive verranno eliminate. Continuare?"
  },
  "tw": {
    "title": "幻燈片",
    "newSlide": "新幻燈片",
    "noSliderTip": "添加一個幻燈片以建立演示檔案。",
    "present": "播放幻燈片",
    "insBefore": "前面插入新幻燈片",
    "insAfter": "後面插入新幻燈片",
    "delete": "刪除",
    "ratio": "長寬比",
    "slideOutput": "導出幻燈片",
    "googleOutput": "導出至googleSlide",
    "slideOption": "幻燈片設置",
    "manual": "手動建立幻燈片",
    "auto": "自動建立幻燈片",
    "autoSlideTips": "這將刪除您所有的幻燈片。您確定要繼續嗎？"
  }
}
</i18n>
<template>
    <setbox :setTitle="$t('title')">
        <div class="slides-panel">
            <div class="slides-ratio">
                <p>{{ $t("ratio") }}</p>
                <i-select class="ratio-dialogs" size="small" v-model="slideRatio" @on-change="setSlideRatio">
                    <i-option v-for="(item, index) in ratioList" :value="index" :label="item.text" :key="index"></i-option>
                </i-select>
            </div>
            <div class="slides-tool">
                <div class="slides-toolblock" :title="$t('manual')" @click="addNewSlider">
                    <iconSymbol class="item-icon" name="sliderAdd" />
                    <p>{{ $t("manual") }}</p>
                </div>
                <div class="slides-toolblock" :title="$t('auto')" @click="checkExitSlider">
                    <iconSymbol class="item-icon" name="sliderAuto" />
                    <p>{{ $t("auto") }}</p>
                </div>
            </div>
            <div class="slides-option" v-if="false">
                <div @click="addNewSlider" class="add-slide">
                    <iconSymbol class="item-icon" :name="'addLayer'" />
                    <span>{{ $t("newSlide") }}</span>
                </div>
                <div class="slide-config">
                    <div class="icon-box" v-if="googleSlide" :content="$t('slideOutput')" v-tippy="{ placement: 'bottom-end' }">
                        <iconSymbol
                            class="item-icon"
                            :class="{ 'ban-item': slidersLen == 0 }"
                            @click.native.stop="toggleSlideOutput"
                            name="sliderPPT"
                        />
                    </div>
                    <div class="icon-box" v-else :content="$t('slideOutput')" v-tippy="{ placement: 'bottom-end' }">
                        <iconSymbol class="item-icon" :class="{ 'ban-item': slidersLen == 0 }" @click.native="outputSlide" name="sliderPPT" />
                    </div>
                    <div class="icon-box" :content="$t('slideOption')" v-tippy="{ placement: 'bottom-end' }">
                        <iconSymbol class="item-icon" @click.native.stop="toggleSlideConfig" name="sliderOptionIcon" />
                    </div>
                    <div v-click-outside="closeSlideOutput" v-show="isShowSlideOutput" class="config-dialog googleslide-dialog">
                        <div class="output-googleslide-btn" @click="outputSlide">{{ $t("slideOutput") }}</div>
                        <div class="output-googleslide-btn" @click="outputGoogle">{{ $t("googleOutput") }}</div>
                    </div>
                    <div v-click-outside="closeSlideConfig" ref="slideConf" v-show="isShowSlideConfig" class="config-dialog">
                        <span>{{ $t("ratio") }}</span>
                        <i-select class="ratio-dialogs" size="small" v-model="slideRatio" @on-change="setSlideRatio">
                            <i-option v-for="(item, index) in ratioList" :value="index" :label="item.text" :key="index"></i-option>
                        </i-select>
                    </div>
                </div>
            </div>
            <div class="slides-preview" ref="allSliders">
                <transition-group name="list-complete" class="all-sliders" v-if="slidersLen" ref="sliderContains" tag="div">
                    <div
                        v-for="(item, index) in sliders"
                        :class="{ 'hidden-slider': index === hiddenIdx }"
                        @mouseenter="showSlideEdit(index)"
                        @mousedown="canvasdown2($event, item.id, index)"
                        @mouseleave="hideSlideEdit"
                        class="sliders-container list-complete-item"
                        :key="item.id"
                    >
                        <div class="slider-index" v-text="index + 1"></div>
                        <div
                            class="canvas-container"
                            @contextmenu="showSlideContext($event, index)"
                            @mousedown="changeActived(index)"
                            @dblclick="toSliderPage(index)"
                            :class="{ 'actived-slider': index === activedSliderIdx }"
                        >
                            <canvas :style="canvasStyle(item)" :id="'sliderPreview' + index"></canvas>
                        </div>
                        <div class="add-icon" @mousedown.stop="" @click="addBeforeSlide($event, index)">
                            <iconSymbol :name="'sliderAddIcon'" class="icon-svg" :class="{ 'active-icon': hoveredSlideIndex === index }" />
                        </div>
                        <!-- <div @click='showSlideContext($event,index)' class='edit-icon'>
						<iconSymbol :name='"sliderEditIcon"'    class='item-icon slider-edit' :class='{"actived-edit": hoveredSlideIndex === index}' />
					</div> -->
                    </div>
                </transition-group>
                <div v-else class="noSlider-tip">
                    <iconSymbol :name="'rightmenu15'" />
                    <div>{{ $t("noSliderTip") }}</div>
                </div>
            </div>
            <div class="slides-more">
                <div class="slidebtn blue" :class="{ ban: sliders.length == 0 }" @click="startPresent">
                    <p :title="$t('present')">{{ $t("present") }}</p>
                </div>
                <div class="slidebtn gray" :class="{ ban: sliders.length == 0 }" @click="outputSlide">
                    <VipIcon v-if="!vip" />
                    <p :title="$t('slideOutput')">{{ $t("slideOutput") }}</p>
                </div>
                <!-- <div class='present' :class='{activePre: sliders.length > 0}'   @click='startPresent'>{{$t("present")}}</div> -->
            </div>
            <div
                v-if="isShowSlideContext"
                ref="slideContext"
                @blur="closeContext"
                :style="{ top: contextPosY + 'px', left: contextPosX + 'px' }"
                tabindex="-1"
                class="menu-container slide-context"
            >
                <div class="menu-item menu-limitW" @click="insSlideBefore" :title="$t('insBefore')">{{ $t("insBefore") }}</div>
                <div class="menu-item menu-limitW" @click="insSlideAfter" :title="$t('insAfter')">{{ $t("insAfter") }}</div>
                <div class="menu-item menu-limitW" @click="delSlide" :title="$t('delete')">{{ $t("delete") }}</div>
            </div>
        </div>
    </setbox>
</template>

<script lang="ts">
    declare var EDView: any;
    declare var PPTExport: any;
    import { Component, Prop, Watch, Vue, Inject } from "vue-property-decorator";
    import setbox from "./BaseSet.vue";
    import appConfig from "@/public/globalConfig";

    @Component({
        components: {
            setbox,
        },
    })
    export default class SlideSet extends Vue {
        @Inject()
        ["showMessage"];
        // 初始数据可以直接声明为实例的属性
        initedSlide: boolean = false;

        scrollActiveIndex: number = null;
        hiddenIdx: number = null;
        dir: boolean = false;
        step: number = 0;
        timer: number = 0;
        get activedSliderIdx() {
            //当前活动的slide
            return this.$store.state.ui.activedSliderIdx;
        }
        set activedSliderIdx(v) {
            this.$store.commit("setStatus", {
                type: "activedSliderIdx",
                data: v,
            });
        }
        get googleSlide() {
            return appConfig.language != "zh";
        }
        @Watch("activedSliderIdx")
        OnIndexChange(val: number) {
            console.log(val);
            this.checkShow();
        }
        isShowSlideContext: boolean = false; //是否显示slide的菜单。
        isShowSlideConfig: boolean = false; // 是否显示slide的配置。
        isShowSlideOutput: boolean = false; // 是否显示slide导出
        hoveredSlideIndex: number = null; //是否显示slide的编辑icon。
        contextPosX: number = 0;
        contextPosY: number = 0;
        ratioList = [
            {
                text: "3:2",
            },
            {
                text: "16:9",
            },
            {
                text: "4:3",
            },
        ];
        get slideRatio() {
            return this.$store.state.ui.slideRatio;
        }
        set slideRatio(v) {
            this.$store.commit("setStatus", {
                type: "slideRatio",
                data: v,
            });
        }
        // computed
        get sliders() {
            return this.$store.state.ui.sliders;
        }
        get slidersLen() {
            return this.sliders.length;
        }
        @Watch("slidersLen")
        OnSlideLenChange(val: number) {
            this.$nextTick(() => {
                this.checkShow();
            });
        }

        get exportLoadedStatus() {
            return this.$store.state.ui.exportLoadedStatus;
        }
        set exportLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "exportLoadedStatus",
                data: v,
            });
        }
        outputSlide() {
            this.$track("rightPanel", "slide", "output slide");
            this.isShowSlideOutput = false;
            if (this.slidersLen == 0) {
                return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
            }
            if (!this.vip) {
                this.$openBuyPage("exportPPT");
                return;
            }
            this.$store.commit("setStatus", {
                type: "ShareLoading",
                data: true,
            });
            this.timer = setTimeout(() => {
                const pptExport = () => {
                    let view = window["_view"];
                    let slideexp = new PPTExport(view._doc);
                    slideexp.ExportSlide();
                };

                if (!this.exportLoadedStatus) {
                    this.exportLoadedStatus = 1;
                    this.$store.dispatch("loadConfig", ["ExpXml4Office.tar"]).then((e) => {
                        this.exportLoadedStatus = 2;
                        pptExport();
                    });
                } else if (this.exportLoadedStatus == 2) {
                    pptExport();
                }
            }, 300);
        }
        outputGoogle() {
            this.isShowSlideOutput = false;
            let ts: any = this;
            ts.$bus.$emit("outputGoogleSlide", 2);
        }
        startScroll(dir: boolean, step: number) {
            this.dir = dir;
            this.step = step;
            if (!window["PRScrollEvent"]) {
                let stepFunc = () => {
                    if (this.dir) {
                        (<HTMLElement>this.$refs.sliderContains).scrollTop += this.step / 2;
                    } else {
                        (<HTMLElement>this.$refs.sliderContains).scrollTop -= this.step / 2;
                    }
                };
                window["PRScrollEvent"] = setInterval(stepFunc, 50);
            }
        }
        canvasdown(event, id: number, idx: number) {
            this.scrollActiveIndex = id;
            let pIndex = idx;
            let moveFlag = false;
            let target = event.target as HTMLElement;
            if (target.classList.contains("edit-icon")) {
                return;
            }
            let y = event.offsetY;
            if (target.classList.contains("canvas-container")) {
                target = target.parentNode as HTMLElement;
            }
            let parent = target.parentNode as HTMLElement;
            let parentContainer = parent.parentNode as HTMLElement;
            let PH = parent.offsetHeight;
            let PCH = parentContainer.offsetHeight;

            let cloneNode;
            document.onmousemove = (e) => {
                if (Math.abs(e.pageY - event.pageY) < 6) return;
                let moveTarget = e.target as HTMLElement;
                if (moveTarget.classList.contains("canvas-container")) {
                    moveTarget = moveTarget.parentNode as HTMLElement;
                }
                if (!parentContainer.contains(moveTarget)) {
                    return;
                }
                let PCTop = parentContainer.scrollTop;
                let topOffset = moveTarget.offsetTop + e.offsetY - PCTop;
                if (PH > PCH) {
                    //可以滚动
                    if (topOffset < 50 || topOffset > PCH - 50) {
                        if (topOffset < 20 && PCTop !== 0) {
                            this.startScroll(false, 20 - topOffset);
                        } else if (topOffset > PCH - 20 && PCTop !== PH - PCH) {
                            this.startScroll(true, 20 - (PCH - topOffset));
                        }
                    }
                }

                if (moveFlag) {
                    let index = parseInt(moveTarget.dataset.idx);
                    let dy = moveTarget.offsetTop + e.offsetY - y;
                    cloneNode.style.top = dy + "px";
                    if (this.hiddenIdx != index) {
                        this.$store.commit("swap2Slide", {
                            pIndex: this.hiddenIdx,
                            index,
                        });
                        this.hiddenIdx = index;
                    }
                } else if (e.offsetY !== event.offsetY) {
                    this.hiddenIdx = idx;
                    moveFlag = true;
                    cloneNode = target.cloneNode(true);
                    cloneNode.removeChild(cloneNode.lastChild);
                    cloneNode.classList.remove("list-complete-item");
                    cloneNode.style.position = "absolute";
                    cloneNode.style.left = "26px";
                    cloneNode.style.top = moveTarget.offsetTop + e.offsetY - y + "px";
                    cloneNode.style.zIndex = 1;
                    cloneNode.style.opacity = "";
                    cloneNode.style.height = "114px";
                    cloneNode.style.pointerEvents = "none";
                    cloneNode.style.borderColor = "#57a3f3";
                    let sourceCanvas = target.children[1].children[0] as HTMLCanvasElement;
                    let canvas = cloneNode.children[1].children[0] as HTMLCanvasElement;
                    canvas.width = sourceCanvas.width;
                    canvas.height = sourceCanvas.height;
                    canvas.getContext("2d").drawImage(sourceCanvas, 0, 0);
                    parent.insertBefore(cloneNode, parent.firstChild);
                }
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                if (window["PRScrollEvent"]) {
                    clearInterval(window["PRScrollEvent"]);
                    window["PRScrollEvent"] = undefined;
                }
                if (moveFlag) {
                    window["_view"].dragSlide(pIndex, this.hiddenIdx);
                    this.changeActived(this.hiddenIdx);
                    parent.removeChild(cloneNode);
                    this.hiddenIdx = null;
                }
            };
        }
        canvasdown2(event, id: number, idx: number) {
            this.scrollActiveIndex = id;
            let pIndex = idx;
            let moveFlag = false;
            let target = event.target as HTMLElement;

            if (target.classList.contains("edit-icon")) {
                return;
            }
            let y = event.offsetY;
            if (target.classList.contains("canvas-container")) {
                target = target.parentNode as HTMLElement;
            }
            let parent = target.parentNode as HTMLElement;
            let parentContainer = parent.parentNode as HTMLElement;
            let PH = parent.offsetHeight;
            let PCH = parentContainer.offsetHeight;
            let cloneNode;

            let PCT = parentContainer.getBoundingClientRect()["y"] + 20,
                clickTop = event.clientY - y,
                slideCount = this.sliders.length,
                baseScrollTop = parentContainer.scrollTop,
                crossTop = 0;

            document.onmousemove = (e) => {
                if (Math.abs(e.pageY - event.pageY) < 6) return;

                let scrollTop = parentContainer.scrollTop - baseScrollTop,
                    moveTop = e.clientY;

                this.hiddenIdx = idx;

                let offsetY = moveTop - clickTop + scrollTop + crossTop;

                if (moveFlag) {
                    if (offsetY < 0) {
                        // 上移
                        let num = idx;
                        let height = offsetY;
                        for (let i = idx; i >= 0; i--) {
                            if (height + 123 < 0 && num > 0) {
                                height += 123;
                                crossTop += 123;
                                this.hiddenIdx = --num;
                                [this.sliders[i], this.sliders[i - 1]] = [this.sliders[i - 1], this.sliders[i]];
                                this.$forceUpdate();
                            } else {
                                idx = num;
                                this.hiddenIdx = num;
                                break;
                            }
                        }
                    } else {
                        // 下移
                        let num = idx;
                        let height = offsetY;
                        for (let i = idx; i <= slideCount - 1; i++) {
                            if (height - 123 > 0 && num < slideCount - 1) {
                                height -= 123;
                                crossTop -= 123;
                                [this.sliders[i], this.sliders[i + 1]] = [this.sliders[i + 1], this.sliders[i]];
                                this.hiddenIdx = ++num;
                                this.$forceUpdate();
                            } else {
                                idx = num;
                                this.hiddenIdx = num;
                                break;
                            }
                        }
                    }
                    cloneNode.style.top = moveTop - clickTop + scrollTop + clickTop - PCT - 50 + baseScrollTop + "px";
                } else {
                    this.hiddenIdx = idx;
                    moveFlag = true;
                    cloneNode = target.cloneNode(true);
                    cloneNode.removeChild(cloneNode.lastChild);
                    cloneNode.classList.remove("list-complete-item");
                    cloneNode.style.position = "absolute";
                    cloneNode.style.left = "26px";
                    cloneNode.style.top = clickTop - PCT - 50 + y + baseScrollTop + "px";
                    cloneNode.style.zIndex = 1;
                    cloneNode.style.opacity = "";
                    cloneNode.style.height = "114px";
                    cloneNode.style.pointerEvents = "none";
                    cloneNode.style.borderColor = "#57a3f3";
                    let sourceCanvas = target.children[1].children[0] as HTMLCanvasElement;
                    let canvas = cloneNode.children[1].children[0] as HTMLCanvasElement;
                    canvas.width = sourceCanvas.width;
                    canvas.height = sourceCanvas.height;
                    canvas.getContext("2d").drawImage(sourceCanvas, 0, 0);
                    parent.insertBefore(cloneNode, parent.firstChild);
                }
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                if (window["PRScrollEvent"]) {
                    clearInterval(window["PRScrollEvent"]);
                    window["PRScrollEvent"] = undefined;
                }
                if (moveFlag) {
                    window["_view"].dragSlide(pIndex, this.hiddenIdx);
                    this.changeActived(this.hiddenIdx);
                    parent.removeChild(cloneNode);
                    this.hiddenIdx = null;
                }
            };
        }
        get isPreviewSlide() {
            return this.$store.state.ui.isPreviewSlide;
        }
        set isPreviewSlide(v) {
            this.$store.commit("setStatus", {
                type: "isPreviewSlide",
                data: v,
            });
        }
        toggleSlideConfig() {
            this.isShowSlideConfig = !this.isShowSlideConfig;
            this.isShowSlideConfig && (this.isShowSlideOutput = false);
        }
        toggleSlideOutput() {
            this.isShowSlideOutput = !this.isShowSlideOutput;
            this.isShowSlideOutput && (this.isShowSlideConfig = false);
        }
        closeSlideConfig() {
            this.isShowSlideConfig = false;
        }
        closeSlideOutput() {
            this.isShowSlideOutput = false;
        }
        removeSlideIdx() {
            this.activedSliderIdx = null;
        }
        showSlideContext(e: MouseEvent, index: number) {
            console.log(e);
            console.log(e.target);
            if (this.hiddenIdx) return;
            this.changeActived(index);
            this.isShowSlideContext = true;
            let target = e.target as HTMLElement;
            let x = e.offsetX + target.offsetLeft + 20;
            if (target.classList.contains("canvas-container")) {
                target = target.parentNode as HTMLElement;
            }
            let y = e.offsetY + target.offsetTop + 50 - (<any>this.$refs.allSliders).scrollTop;
            this.contextPosX = x;
            this.contextPosY = y;
            if (120 + e.pageX + 40 > window.innerWidth) {
                // 150 refer to preview width  40 refer to rightmenu width
                this.contextPosX = x - 120;
            }
            this.$nextTick(() => {
                (<any>this.$refs.slideContext).focus();
            });
        }
        closeContext() {
            this.isShowSlideContext = false;
        }
        @Watch("sliders", { deep: true })
        onSlidersChanged(val: number, oldVal: number) {
            if (val) {
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.sliders.forEach((item, index) => {
                            if (!item.previewRendered) {
                                this.renderPreview(item, index);
                                item.previewRendered = true;
                            }
                        });
                    });
                }, 1000);
            }
        }
        canvasStyle(item) {
            let width_limit = 210,
                height_limit = 118;
            let height = 210 * item.slideRatio;
            let width = 210;
            if (width * item.slideRatio > height_limit) {
                width = height_limit / item.slideRatio;
                height = height_limit;
            } else {
                width = width_limit;
                height = width * item.slideRatio;
            }
            return {
                width: `${width}px`,
                height: `${height}px`,
            };
        }
        changeActived(index) {
            this.activedSliderIdx = index;
            window["_view"].setActiveSlide(index);
        }
        addNewSlider() {
            this.$track("rightPanel", "slide", "new slide");
            this.activedSliderIdx = this.slidersLen;
            this.sensors.track("addSlide", {
                Catalogues: "SpecificFunctions",
            });
            window["_view"].addSlideItem();
        }
        autoSlideTimer = 0;
        autoSlider() {
            clearTimeout(this.autoSlideTimer);
            this.autoSlideTimer = setTimeout(() => {
                window["_view"].addAllPageSlide();
            }, 300);
        }
        checkExitSlider() {
            if (this.slidersLen > 0) {
                let msg = this.$t("autoSlideTips");
                this.showMessage({
                    sponsor: "sliderCover",
                    uniqueListenr: true,
                    type: 0,
                    btnType: 1,
                    content: msg,
                });
            } else {
                this.autoSlider();
            }
        }
        addBeforeSlide(e, index) {
            this.insertSlide(1, index);
            this.activedSliderIdx = index + 1;
        }
        insSlideBefore() {
            this.insertSlide(0, this.activedSliderIdx);
            this.closeContext();
        }
        insSlideAfter() {
            this.insertSlide(1, this.activedSliderIdx);
            this.activedSliderIdx++;
            this.closeContext();
        }
        insertSlide(type, index) {
            window["_view"].insertSlideItem(type, index);
        }
        delSlide() {
            window["_view"].removeSlideItem();
            this.closeContext();
        }
        renderPreview(item, index) {
            console.log("render");
            let canvas = document.getElementById("sliderPreview" + index);
            window["_view"].updateSlidePreview(index, canvas);
        }
        showSlideEdit(index) {
            this.hoveredSlideIndex = index;
        }
        checkShow() {
            console.log(1111111111);
            if (this.activedSliderIdx == null) return;
            let top = this.activedSliderIdx * 134;
            let bot = top + 118;
            let rootEle = this.$refs.allSliders as HTMLElement;
            let totalTop = rootEle.scrollTop;
            let totalBot = totalTop + rootEle.clientHeight - 40;
            if (top < totalTop) {
                rootEle.scrollTo({
                    top: top,
                    left: 0,
                    behavior: "smooth",
                });
            }
            if (bot > totalBot) {
                rootEle.scrollBy({
                    top: bot - totalBot,
                    left: 0,
                    behavior: "smooth",
                });
            }
        }
        hideSlideEdit() {
            this.hoveredSlideIndex = null;
        }
        toSliderPage(index: number) {
            window["_view"].dbClickSlide(index);
        }
        setSlideRatio(index) {
            this.$track("rightPanel", "slide", "set slide ratio");
            window["_view"].changeSlideRatio(index);
        }
        startPresent() {
            this.$track("rightPanel", "slide", "play slide");
            this.sensors.track("playPresentation", {
                Catalogues: "SpecificFunctions",
            });
            let idx = this.activedSliderIdx === null ? 0 : this.activedSliderIdx;
            if (window.EDCONFIG.IS_SDK && !this.vip) {
                this.$openBuyPage("playSlider", "", {
                    pageIndex: idx,
                    isPageSlide: false,
                });
                return;
            }
            this.$bus.$emit("startSliderPre", idx);
        }
        activated() {
            this.activeFunc();
            this.$bus.$emit("setRightViewTitle", "slideSet");
        }
        deactivated() {
            this.deactiveFunc();
        }
        activeFunc() {
            if (!this.initedSlide) {
                this.$store.commit("cleanSlides");
                window["_view"].pushAllSlidetoUI();
                this.initedSlide = true;
            }

            window["_view"].openSlidePanel();
            this.isPreviewSlide = true;
        }
        deactiveFunc() {
            this.initedSlide = false;
            window["_view"].closeSlidePanel();
            this.isPreviewSlide = false;
        }

        //生命周期
        mounted() {
            let ts = this;
            let rootEle = this.$refs.allSliders as HTMLElement;
            if (rootEle) {
                let rootFunc = () => {
                    ts.isShowSlideContext = false;
                };
                rootEle.addEventListener("DOMMouseScroll", rootFunc, { passive: false }); //firefox;
                rootEle.addEventListener("wheel", rootFunc, { passive: false }); //IE/Opera/Chrome/Safari
            }
            setTimeout(() => {
                this.sliders.forEach((item, index) => {
                    if (!item.previewRendered) {
                        this.renderPreview(item, index);
                        item.previewRendered = true;
                    }
                });
            }, 200);
        }

        created() {
            let ts = this;
            this.$bus.$on("slideToggle", (data) => {
                if (data) {
                    this.activeFunc();
                } else {
                    this.deactiveFunc();
                }
            });
            ts.$bus.$on("msgOperation-sliderCover", (data) => {
                if (data.sponsor == "sliderCover") {
                    if (data.data) this.autoSlider();
                }
            });
        }
        beforeDestroy() {
            this.$bus.$off("msgOperation-sliderCover");
            this.initedSlide = false;
        }
    }
</script>
